import { AVATAR_COLORS, AVATAR_EMOJIS } from "@/engine/state/avatarEmoji";
import { useTranslation } from "react-i18next";
import { setAvatarChoice, useAvatarChoice } from "@/hooks/useAvatarChoice";
import { cn } from "@/engine/support/classNames";

/** Color and animal grids used in the full profile editor. */
export function AvatarGrids() {
  const choice = useAvatarChoice();
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <div>
        <p className="mb-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          {t("avatar.color")}
        </p>
        <div className="grid grid-cols-8 gap-1 sm:grid-cols-12">
          {AVATAR_COLORS.map((color) => (
            <button
              key={color}
              type="button"
              aria-label={t("avatar.chooseColor", { color })}
              aria-pressed={choice.color === color}
              onClick={() =>
                setAvatarChoice({
                  color: choice.color === color ? null : color,
                })
              }
              className={cn(
                "h-6 w-full rounded-md border border-border/40 transition-transform hover:scale-110",
                choice.color === color &&
                  "ring-2 ring-primary ring-offset-1 ring-offset-background",
              )}
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      </div>

      <div>
        <p className="mb-1.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          {t("avatar.animal")}
        </p>
        <div className="grid grid-cols-8 gap-1 sm:grid-cols-10">
          {AVATAR_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              aria-label={t("avatar.chooseAnimal", { emoji })}
              aria-pressed={choice.emoji === emoji}
              onClick={() =>
                setAvatarChoice({
                  emoji: choice.emoji === emoji ? null : emoji,
                })
              }
              className={cn(
                "flex h-9 items-center justify-center rounded-md text-lg transition-colors hover:bg-muted sm:h-8",
                choice.emoji === emoji && "bg-muted ring-2 ring-primary",
              )}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
